export default __webpack_public_path__ + "static/media/Group 108.3888fee7.png";